<div class="rox-symbol-trading-list card bg-dark-lighter text-white">
  <div class="card-body">
    <div class="row rox-symbol-trading-list__title">
      <div class="col fs-16">
        <span>Trading volume - point conversion</span>
      </div>
    </div>
    <div class="row mt-3 rox-symbol-trading-list__body">
      <div class="col-md-6 rox-symbol-trading-list__body-filter mt-1" >
        <div class="input-group search-group">
          <input
            type="text"
            [(ngModel)]="filter.search"
            class="form-control bg-dark"
            name="keyword"
            placeholder="Search"/>
          <button 
            class="btn btn-main mr-2" 
            type="button" 
            (click)="search()">
            Search
          </button>
        </div>
        <button type="submit" 
          class="btn btn-main refresh-btn" 
          (click)="refresh()">
          Refresh
        </button>
      </div>
      <div class="col-md-6 d-flex justify-content-end mt-1">
        <button 
          type="submit" 
          class="btn btn-main mr-2 import-csv"
          id="import-btn"
          (click)="chooseFileImportCSV()">
          Import CSV
        </button>
        <input
          id="symbol-list-trading-import-btn"
          class=""
          style="visibility: hidden; width: 0; height: 0; min-width: 0"
          accept=".csv" 
          type="file"
          name="importCsv"
          [(ngModel)]="files"
          #importCsv
          (change)="handleImportCSV(importCsv.files)">
      </div>
    </div>
    <div class="symbol-suffix d-flex align-items-center mr-2 mt-4 ">
      <mat-label class="mr-2">Symbol suffix</mat-label>
      <select 
        [(ngModel)]="filter['symbolSuffix']" 
        (change)="apply()">
        <option 
          *ngFor="let symbol of symbolSuffixList" 
          [value]="symbol">
          {{symbol}}
        </option>
      </select>
    </div>
    <div class="row mt-3 rox-symbol-trading-list__table">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center">Symbol</th>
                <th class="text-center">Volume</th>
                <th class="text-center">Exchanged point</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let symbol of symbolList; let i = index">
                <td>{{symbol.symbol}}</td>
                <td>{{symbol.volume | number: '1.3-3'}}</td>
                <td>{{symbol.point | number: '1.2-2'}}</td>
                <td>
                  <i class="fa fa-pencil-square-o mr-2 icon" 
                    (click)="editSymbol(symbol,i)">
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<rox-dialog-prime
  [show]="showEditSymbolDialog"
  [showEditBtn]="symbolDetail.readonly?true:false"
  [titleName]="'Edit point conversion'"
  (save)="savePointDialog()"
  (close)="closePointDialog()"
  [disableSaveBtn]="disableSaveBtn"
  (edit)="editPointDialog()"
  [showSaveBtn]="(!error && !symbolDetail.readonly)">
  <content>
      <table>
        <tr class="mb-2">
          <td>  
            <span>Symbol:</span>
          </td>
          <td>
            <span class="ml-2">{{symbolDetail.symbol}}</span>
          </td>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Volume:</span>
          </td>
          <td>  
            <input
              type="text"
              [disabled]="symbolDetail.readonly?true:false"
              class="mx-2"
              maxlength="12"
              mask="0*.000"
              (keyup)="onChangePointConversion($event)"
              [dropSpecialCharacters]="false"
              [(ngModel)]="symbolDetail.volume"
              required
              #volume="ngModel"
          ></td>
        <div class="errors-group" *ngIf="volume.errors">
          <small class="error-message" *ngIf="volume.errors?.required">
            {{'VALIDATIONS.REQUIRED' | translate}}
          </small>
        </div>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Exchanged point
            </span>
          </td>
          <td>
            <input 
              type="text"
              [disabled]="symbolDetail.readonly?true:false"
              class="mx-2"
              [(ngModel)]="symbolDetail.point"
              mask="0*.00"
              required
              maxlength="12"
              #point="ngModel"
              (keyup)="onChangePointConversion($event)"
              [dropSpecialCharacters]="false">
          </td>
          <div class="errors-group" *ngIf="point.errors">
            <small class="error-message" *ngIf="point.errors?.required">
              {{'VALIDATIONS.REQUIRED' | translate}}
            </small>
          </div>
        </tr>
      </table>
      <div class="text-red mt-2" *ngIf="error">
        {{error}}
      </div>
  </content>
</rox-dialog-prime>
<rox-dialog-prime
  [show]="showErrorImport"
  (close)="showErrorImport = false"
  [titleName]="'Import Error!'"
  [showSaveBtn]="false">
  <content>
    <span [innerHTML]="errImportText"></span>
  </content>
</rox-dialog-prime>